// Implements: F-UIX-010
/**
 * The head of a page (the mockup's `.ph`): the one `h1`, and under it a sentence saying what the page
 * is for. The `h1` takes the focus programmatically (`tabindex="-1"`) when a route change moves it,
 * but is not a tab stop. Page-level actions live in the topbar (`PageActions`), not here.
 */

import type { ReactElement, ReactNode } from "react";

import styles from "./PageHeader.module.css";

export interface PageHeaderProps {
  readonly title: string;
  readonly subtitle?: string | undefined;
  /** Something small on the subtitle's line (a help link that opens a popover), never an action. */
  readonly aside?: ReactNode;
}

export function PageHeader({ title, subtitle, aside }: PageHeaderProps): ReactElement {
  return (
    <div className={styles.header}>
      <h1 className={styles.title} tabIndex={-1}>
        {title}
      </h1>
      {subtitle === undefined && aside === undefined ? null : (
        <div className={styles.subline}>
          {subtitle === undefined ? null : <p className={styles.subtitle}>{subtitle}</p>}
          {aside}
        </div>
      )}
    </div>
  );
}
